import { css } from 'styled-components';
import token from 'styled-token';

/** @class ProgressStepperCurrentLabelMixin */
/** @method */
export var ProgressStepperCurrentLabelMixin = function ProgressStepperCurrentLabelMixin(props) {
  return token('ProgressStepper.label.marginTop.current', function (marginTop) {
    if (marginTop === void 0) {
      marginTop = 0;
    }
    return css(["margin-top:", "px;"], marginTop);
  })(props);
};